module.exports = __webpack_public_path__ + "img/share-linke-logo.9bf64bf1.svg";